export default __webpack_public_path__ + "static/media/bigger-stronger-better.adf47a08.png";